import { render, staticRenderFns } from "./orderServicerCompleted.vue?vue&type=template&id=9a7ab9e4&"
import script from "./orderServicerCompleted.vue?vue&type=script&lang=ts&"
export * from "./orderServicerCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports